import React, { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import ListingTableWithCellInputs from '@components/table/with-cell-inputs/ListingTableWithCellInputs';
import { IListingData } from '@models/listing';
import { headers } from './content';
import { getCancellationAmendmentDetails } from '../../queries';
import { mapToCancellationAmendmentDetails } from './utils';

interface IInsuredDetailsListingWidgetProps {
  selectedAmendmentID: string;
}

const InsuredDetailsListingWidget: React.FC<
  IInsuredDetailsListingWidgetProps
> = ({ selectedAmendmentID }) => {
  const [tableData, setTableData] = useState<IListingData>({
    pagedItems: {},
    totalCount: 0,
    pageNumber: 1,
    pageSize: 10,
  });

  const [getCancellationAmendmentDetailsLazy, { data, loading }] = useLazyQuery(
    getCancellationAmendmentDetails
  );

  useEffect(() => {
    const initialize = () => {
      if (!data) {
        getCancellationAmendmentDetailsLazy({
          variables: { selectedAmendmentID },
        });
      } else {
        const listingData = mapToCancellationAmendmentDetails(data);
        setTableData(listingData);
      }
    };

    initialize();
  }, [selectedAmendmentID, data, getCancellationAmendmentDetailsLazy]);

  const dynamicRowMessage = (row: any): string[] => {
    return row.isOverridden ? ['Overridden values'] : [];
  };

  return (
    <div style={{ width: '900px' }}>
      <ListingTableWithCellInputs
        name="InsuredDetails"
        inlineTitle="Insured Details"
        headers={headers}
        data={tableData}
        loader={loading}
        disableSelection={false}
        inline
        dynamicRowMessage={dynamicRowMessage}
        handleUpdate={() => {}}
        actions={[]}
      />
    </div>
  );
};

export default InsuredDetailsListingWidget;
